import {Injectable} from '@angular/core';
import {Klausel, Polizze, Position, PositionResult, Vertrag, VertragResult} from '@pezi/entities';
import {createStore, withProps} from "@ngneat/elf";
import {persistState, sessionStorageStrategy} from "@ngneat/elf-persist-state";

export interface ActivePoliceState {
  //polint
  police: Polizze;
  policeLoading: boolean;
  policeLoadingError: boolean;

  vertraege: VertragResult[]
  vertraegeLoading: boolean;

  // polint, verId
  vertrag: Vertrag;
  vertragLoading: boolean;
  vertragLoadingError: boolean;

  vertragKlauseln: Klausel[];
  vertragKlauselnLoading: boolean;

  avbs: Klausel[];
  avbsLoading: boolean;

  positionen: PositionResult[];
  positionenLoading: boolean;

  // polint, verId, posId
  position: Position;
  positionLoading: boolean;
  positionLoadingError: boolean;

  positionKlauseln: Klausel[];
  positionKlauselnLoading: boolean;
}

export function createInitialState(): ActivePoliceState {
  return {
    police: undefined,
    policeLoading: false,
    policeLoadingError: false,
    vertraege:        undefined,
    vertraegeLoading: false,
    vertrag: undefined,
    vertragLoading: false,
    vertragLoadingError: false,
    vertragKlauseln:  undefined,
    vertragKlauselnLoading: false,
    avbs:             undefined,
    avbsLoading: false,
    positionen:       undefined,
    positionenLoading: false,
    position: undefined,
    positionLoading: false,
    positionLoadingError: false,
    positionKlauseln: undefined,
    positionKlauselnLoading: false,
  };
}

@Injectable({providedIn: 'root'})
export class ActivePoliceStore {

  data = createStore({name: 'active-police'}, withProps<ActivePoliceState>(createInitialState()));
  persist = persistState(this.data, {
    key: 'active-police',
    storage: sessionStorageStrategy,
  });

}

